/**
 * Purpose: Heading + description + action row that opens a module's content.
 *          Distinct from DashboardCard: this is the module's own title block,
 *          the card is a surface. Modules use both.
 * Inputs: title, description, action (node), children.
 * Outputs: section with an h2 heading (module panels are the page's sections).
 */
import React from 'react';

const DashboardSection = ({ title, description = null, action = null, children }) => (
  <section className="space-y-4">
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h2 className="text-lg font-bold text-gray-900 dark:text-gray-100 sm:text-xl">{title}</h2>
        {description && (
          <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">{description}</p>
        )}
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
    {children}
  </section>
);

export default DashboardSection;
